import { render, staticRenderFns } from "./PointsRelation.vue?vue&type=template&id=70cb6bbf"
import script from "./PointsRelation.vue?vue&type=script&lang=js"
export * from "./PointsRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports